import React, { useState } from 'react';
import { useInit } from '../../../Contexts/InitProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField, {
    InputPassword,
    SelectOption,
    TextareaField,
    addOption
} from '../../../utils/InputField';
import countryAr from '../../../utils/country.json';
import { handleCreateCustomerOpe } from '../CustomerOperation';
import { useCustomer } from '../CustomerProvider';

export function ImageUploadPreview() {
    const handleUploadImg = (e) => {
        console.log(e.target.files[0]);
    };

    return (
        <div>
            <label htmlFor="imageUploadLabel">
                <span>Choose image</span>
                <input
                    type="file"
                    name="OrganizationIcon"
                    id="imageUploadLabel"
                    className="appearance-none "
                    accept="image/*"
                    onChange={handleUploadImg}
                />
            </label>
        </div>
    );
}

function CreateCustomerModal({ setCreateCustomerModal }) {
    const { setReloadKey } = useCustomer();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { initInfo } = useInit();
    const [formData, setFormData] = useState({
        CustomerType: '',
        FirstName: '',
        LastName: '',
        Organization: '',
        OrganizationIcon: '',
        Email: '',
        Phone: '',
        Address: '',
        Country: '',
        State: '',
        City: '',
        Zip: '',
        Password: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((d) => ({ ...d, [name]: value }));
    };
    const { setMessage } = useTemplate();
    const handleCreateCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        handleCreateCustomerOpe(formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                setCreateCustomerModal(false);
                setReloadKey((d) => d + 1);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form
            onSubmit={handleCreateCustomer}
            encType="multipart/form-data"
            className="flex flex-col gap-4"
        >
            <SelectOption
                label="Customer Role"
                name="CustomerType"
                formData={formData}
                onChange={handleChange}
                options={initInfo?.roles
                    ?.filter(({ key }) => key !== 'admin')
                    ?.map(({ key, title }) => addOption(key, title, key))}
                required
            />
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Smith"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <TextareaField
                label="Address"
                name="Address"
                placeholder='e.g. "1234 Main St"'
                formData={formData}
                onChange={handleChange}
                className="h-16"
                required
            />
            <div className=" flex flex-row gap-x-4">
                <SelectOption
                    label="Country"
                    name="Country"
                    formData={formData}
                    onChange={handleChange}
                    options={countryAr?.map(({ name, code }) => addOption(code, name, code))}
                    required
                />
                <InputField
                    label="State"
                    name="State"
                    placeholder='e.g. "California"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="h-16 flex flex-row gap-x-4">
                <InputField
                    label="City"
                    name="City"
                    placeholder='e.g. "San Francisco"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="ZIP"
                    name="Zip"
                    placeholder='e.g. "94107"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <InputPassword
                label="Default Password"
                name="Password"
                placeholder='e.g. "********"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <p className="text-sm text-error/90 font-normal leading-6 mb-3">
                Password must contain at least 1 Letter, 1 Number & 1 Symbol. Minimum length is 8
                characters.
            </p>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => setCreateCustomerModal(false)} />
                <ButtonPrimary title="Create" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default CreateCustomerModal;
